import React, { useState } from 'react';
import './App.css';
import { Call, Dial, Login, Register } from './Components';
import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import UserCreateContext from './Components/Context/context';
function App() {
  const [userData, setUserData] = useState('');
  return (
    <div className="App">
      <UserCreateContext.Provider value={{ userData, setUserData }}>

        <Router>
          <Routes>
            <Route path='/' element={<Login />}></Route>
            <Route path='/login' element={<Login />}></Route>
            <Route path='/register' element={<Register />}></Route>
            <Route path='/dial' element={<Dial />}></Route>
            <Route path='/call' element={<Call />}></Route>
          </Routes>
        </Router>

      </UserCreateContext.Provider>

      {/* <Register/> */}
      {/* <Login /> */}
      {/* <Dial/> */}
      {/* <Call /> */}
    </div>
  );
}

export default App;
